/* =========================================================
 * optimizeやタグマネージャーで計測、ターゲティング、トリガーに仕様するカスタムイベントを設定する
========================================================= */

export const setCustomEvent = (eventName) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';

  const pushDataLayer = document.createTextNode('dataLayer.push({"event": "' + eventName + '"})');
  script.appendChild(pushDataLayer);

  const head = document.getElementsByTagName('head')[0];
  head.appendChild(script);
}
